const knownSources = {
    'finance.yahoo.com': 'Yahoo Finance',
    'yahoo.com': 'Yahoo',
    'bloomberg.com': 'Bloomberg',
    'reuters.com': 'Reuters',
    'marketwatch.com': 'MarketWatch',
    'cnbc.com': 'CNBC',
    'ft.com': 'Financial Times',
    'wsj.com': 'Wall Street Journal',
    'investing.com': 'Investing.com',
    'seekingalpha.com': 'Seeking Alpha',
    'fool.com': 'The Motley Fool',
    'morningstar.com': 'Morningstar',
    'nasdaq.com': 'Nasdaq',
    'benzinga.com': 'Benzinga',
    'zacks.com': 'Zacks',
};

const prettifySource = (value) => {
    const cleaned = String(value || '')
        .replace(/^www\./, '')
        .replace(/\.(com|co\.uk|org|net|io)$/i, '')
        .replace(/[-_]/g, ' ')
        .trim();

    if (!cleaned) return '';

    return cleaned
        .split(' ')
        .map((word) => word ? `${word[0].toUpperCase()}${word.slice(1)}` : '')
        .join(' ');
};

export const newsSourceLabel = (item) => {
    const url = item?.url || '';

    if (url) {
        try {
            const hostname = new URL(url).hostname.toLowerCase().replace(/^www\./, '');
            if (knownSources[hostname]) return knownSources[hostname];

            const rootHost = hostname.split('.').slice(-2).join('.');
            if (knownSources[rootHost]) return knownSources[rootHost];

            return prettifySource(rootHost);
        } catch (e) {
            // Fall through to source label.
        }
    }

    const source = String(item?.source || '').toLowerCase();
    if (!source || source === 'tavily' || source === 'newsdata') {
        return '';
    }

    return prettifySource(source);
};
